import './App.css';
import Homepage from "./pages/Homepage";
import {Container} from "@mui/material";

function App() {
  return (
      <Container sx={{padding: { xs: '0 6px', md: '0 32px' }}}>
        <Homepage/>
      </Container>
  );
}

export default App;
